import { render } from "./Hotel.vue?vue&type=template&id=3a9bfa7b"
import script from "./Hotel.vue?vue&type=script&lang=js"
export * from "./Hotel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__